const model = {
    name: 'Variables',
    properties: {
        sections: { type: 'array' },
    },
};
export default model;
